module.exports = __webpack_public_path__ + "assets/img/zh-Hant-c8f3979d.png";